import type { match } from 'react-router-dom'
import { resolveSerial } from '../../common'
import { setCoupon, setGCLID, setGroupId } from '../../reducers/landing.slice'
import { landingResolver } from '../../route-resolvers/landingResolver'

type MatchSignUpPage = Maybe<match<{ readonly groupId?: string }>>

export const resolveSignUpPage = /*@__PURE__*/ resolveSerial(
	({ dispatch }, location, match: MatchSignUpPage) => {
		const groupIdParam = match?.params.groupId
		const queryParams = new URLSearchParams(location.search)
		const [coupon, gclid] = [queryParams.get('coupon'), queryParams.get('gclid')]

		// If we have a google ads attribution id, set it in state
		if (gclid) {
			dispatch(setGCLID(gclid))
		}

		if (coupon) {
			dispatch(setCoupon(coupon))
		}

		if (groupIdParam) {
			dispatch(setGroupId(groupIdParam))
		}
	},
	landingResolver,
)
